import { useAppSettingsStore } from '@infuse/utils';
import Cookies from 'js-cookie';
import { Authenticator, LoginResult, User, UserNameType } from './authenticator';

export class BasicAuthenticator extends Authenticator {
  private secureCookies =
    !useAppSettingsStore().getAsBool('VITE_ALLOW_INSECURE_COOKIES') && window.location.protocol !== 'http:';

  getAuthenticationHeader(): Promise<string> {
    return new Promise<string>((resolve) => {
      const sessionToken = Cookies.get('sessionToken');
      resolve(`Basic ${sessionToken}`);
    });
  }

  getUser(): Promise<User> {
    return new Promise<User>((resolve) => {
      const username = Cookies.get('username');
      const sessionToken = Cookies.get('sessionToken');
      resolve({
        email: username,
        authorizationHeader: `Basic ${sessionToken}`
      });
    });
  }

  userNameType(): UserNameType {
    return UserNameType.TEXT;
  }

  requiresCredentials(): boolean {
    return true;
  }

  isAuthenticated(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const isLoggedIn = Cookies.get('isLoggedIn') === 'true' || false;
      resolve(isLoggedIn);
    });
  }

  login(username: string, password: string): Promise<LoginResult> {
    return new Promise<LoginResult>((resolve) => {
      // CRITICAL SECURITY: Never store plain text passwords!
      // Only store non-sensitive session information
      Cookies.set('username', username, { secure: this.secureCookies, expires: 365 });
      // Store only a session token or hashed value, NEVER the plain password
      const sessionToken = btoa(username + ':' + password); // Basic session identifier
      Cookies.set('sessionToken', sessionToken, { secure: this.secureCookies, expires: 1 });
      Cookies.set('isLoggedIn', 'true', { secure: this.secureCookies, expires: 1 });
      resolve({ isLoggedIn: true, totpSetupDetails: { authenticatorCode: '', qrCodeUrl: '' } });
    });
  }

  enableForgotPassword(): boolean {
    return false;
  }

  forgotPassword(username: string): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  forgotPasswordConfirm(username: string, password: string, code: string): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  logout(): Promise<void> {
    return new Promise<void>((resolve) => {
      Cookies.remove('username');
      Cookies.remove('sessionToken');
      Cookies.remove('isLoggedIn');
      resolve();
    });
  }
}
